import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { tx } from "@/i18n/tx";

export function ErrorState({ title = "Något gick fel", description, onRetry }) {
  return (
    <div
      data-testid="error-state"
      className="flex flex-col items-center justify-center gap-3 rounded-xl border border-destructive/30 bg-destructive/5 py-16 text-center"
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-destructive/15 text-destructive">
        <AlertTriangle className="h-6 w-6" />
      </div>
      <div>
        <p className="font-display text-base font-semibold">{title}</p>
        {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} data-testid="error-retry-button" className="mt-1">
          {tx("Försök igen")}
        </Button>
      )}
    </div>
  );
}
